import React, { useState, forwardRef } from "react";
import {
  makeStyles,
  ListItem,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
} from "@material-ui/core/";
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  listItem: {
    fontSize: "1rem",
    color: "#005598",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    // color:"red"
  },
  ListItemRoot: {
    width: "auto",
    padding: "0 0.5rem",
  },
}));
const styles = {
  display: "flex",
  alignItems: "center",
  //  color:"red"
};
const MenuItems = forwardRef((props, ref) => {
  const classes = useStyle(props);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, key) => {
    event.currentTarget.className += " active";
    setAnchorEl(event.currentTarget);
    if (props.view === "mobile") {
      if (
        key === "Events" ||
        key === "Account" ||
        key === "Documents" ||
        key === "Course Catalog" ||
        key === "About" ||
         key === "Student Dashboard"
      ) {
        props.parentCallback("MenuBargetsClosed");
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ListItem ref={ref} disableGutters classes={{ root: classes.ListItemRoot }}>
      <Link
        className={classes.listItem}
        aria-controls={`sub-menu-id-${props.id}`}
        // style={styles}
        onClick={(event) => handleClick(event, props.name, props.view)}
        to={props.url}
        style={{
          display: props.display ? props.display : "block",
          marginBottom: props.view === "mobile" ? "12px" : "",
        }}
      >
        {props.name}
      </Link>
      <Popper
        id={`sub-menu-id-${props.id}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transition
        disablePortal
        style={{ zIndex: 99 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id={`sub-menu-id-${props.id}`}>
                  {props.view === "desktop" && props.hasSubmenu
                    ? props.subMenuItems.map((subItems, subIndex) => {
                        return (
                          <MenuItem
                            key={subIndex}
                            onClick={() => {
                              setAnchorEl(null);
                              props.history.push(subItems.url);
                            }}
                            style={{
                              display: subItems.display
                                ? subItems.display
                                : "block",
                            }}
                          >
                            {subItems.name}
                          </MenuItem>
                        );
                      })
                    : null}
                  {props.view === "mobile" && props.hasSubmenu
                    ? props.subMenuItems.map((subItems, subIndex) => {
                        return (
                          <MenuItem
                            // onClick={handleClose}
                            key={subIndex}
                            onClick={() => {
                              setAnchorEl(null);
                              props.history.push(subItems.url);
                              props.parentCallback("MenuBargetsClosed");
                            }}
                            style={{
                              display: subItems.display
                                ? subItems.display
                                : "block",
                              minHeight: "15px",
                              fontSize: "13px",
                            }}
                          >
                            {subItems.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </ListItem>
  );
});

export default MenuItems;
